import { Backdrop, CircularProgress } from "@mui/material";

interface OlogaLoadingProps {
  open: boolean;
}

const OlogaLoading = ({ open }: OlogaLoadingProps) => {
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default OlogaLoading;
